import React, { useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import {
    AppBar,
    Toolbar,
    Typography,
    IconButton,
    Button,
    Card,
    CardContent,
    Chip,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Avatar,
    Drawer,
    OutlinedInput,
    FormControlLabel,
    Radio,
    RadioGroup,
    TextField,
    Select,
    MenuItem,
    FormControl,
    InputLabel,
    CircularProgress,
} from '@material-ui/core';
import {
    ArrowBack as ArrowBackIcon,
    Close as CloseIcon,
    Visibility as VisibilityIcon,
    WhatsApp as WhatsAppIcon,
} from '@material-ui/icons';
import { routes, formatNumber } from '../../constants.js/misc';
import { getOrderLineSku, getOrderLineUnitPrice } from '../../constants.js/orderProductSearch';
import useStyles from './OrderInfoPageMobile.styles';
import useDrawerStyles from '../OrderPageMobile/OrderPageMobile.styles';
import { useParams } from 'react-router-dom';
import { useEffect } from 'react';
import { Mixpanel } from '../../constants.js/mixpanel';
import { getDynamicFormInfo, getOrderService, updateOrder } from '../../services/orders';
import OrderInvoiceButton from '../../components/OrderInvoice/OrderInvoiceButton';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { setOrderToEdit, setPageState, setRowsPerPageState } from '../../modules/orders';
import { useSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { errorToast, infoToast, successToast } from '../../constants.js/misc';
import {
    paymentStatusConfigs,
    shipmentStatusConfigs,
    statusOrders,
} from '../../constants.js/orders';
import {
    getNormalizedPaymentStatusLabel,
    getOrderOrigin,
} from '../../utils/orderOrigin';
import moment from 'moment';
import { getUserStoresService } from '../../services/store';
import { renderVariants } from '../../components/OrderInfoPage/OrderProductsTable/OrderProductsTable';
import { getCitiesService } from '../../services/misc';
import { getStoreCountries } from '../../services/billing';
import { getCouponService } from '../../services/coupons';

export const OrderInfoPageMobile = ({ orderToEdit, setOrderToEdit, storeId, storeData }) => {
    const { id, orderId } = useParams();
    const { enqueueSnackbar } = useSnackbar();
    const { t } = useTranslation();
    const history = useHistory();
    const classes = useStyles();
    const drawerClasses = useDrawerStyles();

    const [gettingOrder, setGettingOrder] = useState(true);
    const [orderData, setOrderData] = useState({});
    const [userStores, setUserStores] = useState([]);
    const [formInfo, setFormInfo] = useState([]);
    const [isPaymentStatusDrawerOpen, setIsPaymentStatusDrawerOpen] = useState(false);
    const [isShipmentStatusDrawerOpen, setIsShipmentStatusDrawerOpen] = useState(false);
    const [selectedPaymentStatus, setSelectedPaymentStatus] = useState('');
    const [selectedShipmentStatus, setSelectedShipmentStatus] = useState('');
    const [city, setCity] = useState(null);
    const [country, setCountry] = useState(null);
    const [fetchedCouponCode, setFetchedCouponCode] = useState(null);

    const debounceRef = useRef(null);

    const handleEditOrder = () => {
        console.log('Edit order');
    };

    const handleChangeOrderStatus = () => {
        setIsPaymentStatusDrawerOpen(true);
    };

    const handleChangeShippingStatus = () => {
        setIsShipmentStatusDrawerOpen(true);
    };

    const handlePaymentStatusChange = (event) => {
        const value = Number(event.target.value); // radios return string, so convert
        const newPaymentStatus = Object.values(paymentStatusConfigs).find(
            (config) => config.value === value
        );

        setSelectedPaymentStatus(value);
        setOrderData((prev) => ({
            ...prev,
            order_status: { id: newPaymentStatus?.value, name: newPaymentStatus?.label },
            order_status_id: newPaymentStatus?.value,
        }));
    };

    const handleShipmentStatusChange = (event) => {
        const value = Number(event.target.value);
        const newShipmentStatus = Object.values(shipmentStatusConfigs).find(
            (config) => config.value === value
        );

        setSelectedShipmentStatus(value);
        setOrderData((prev) => ({
            ...prev,
            shipping_order_status: { id: newShipmentStatus?.value, name: newShipmentStatus?.label },
            shipping_order_status_id: newShipmentStatus?.value,
        }));
    };

    const handleDateChange = (e) => {
        const value = e.target.value;
        if (moment(value).isValid()) {
            const isoString = moment(value).toISOString();

            setOrderData((prev) => ({
                ...prev,
                created_at: isoString,
            }));

            // clear previous timer if still running
            if (debounceRef.current) {
                clearTimeout(debounceRef.current);
            }

            debounceRef.current = setTimeout(() => {
                updateOrder(storeId, orderData.id, {
                    ...orderData,
                    created_at: isoString,
                }).then(() => {
                    setTimeout(() => {
                        enqueueSnackbar(t('OrderDetail.submitSuccess'), successToast);
                    }, 1500);
                });
            }, 1000);
        }
    };

    const handleOnCommentsChange = (e) => {
        const { value } = e.target;

        // update local state right away
        setOrderData((prev) => ({
            ...prev,
            comments: value,
        }));

        // clear previous timer if still running
        if (debounceRef.current) {
            clearTimeout(debounceRef.current);
        }

        // set new debounce timer
        debounceRef.current = setTimeout(() => {
            updateOrder(storeId, orderData.id, { ...orderData, comments: value }).then(() => {
                setTimeout(() => {
                    enqueueSnackbar(t('OrderDetail.submitSuccess'), successToast);
                }, 1500);
            });
        }, 1000);
    };

    const handleStoreChange = (e) => {
        const storeId = e.target.value;
        const selectedStore = userStores.find((store) => store.id === storeId);

        // Update local state
        setOrderData((prev) => ({
            ...prev,
            user_store_id: storeId,
        }));

        // clear previous timer if still running
        if (debounceRef.current) {
            clearTimeout(debounceRef.current);
        }
        // Call backend
        debounceRef.current = setTimeout(() => {
            updateOrder(storeId, orderData.id, {
                user_store_id: storeId,
            }).then(() => {
                setTimeout(() => {
                    enqueueSnackbar(t('OrderDetail.submitSuccess'), successToast);
                }, 1500);
            });
        }, 1000);
    };

    // Por ahora costos de envío son los del store (delivery_cost_enabled + delivery_cost_details)
    const getDeliveryCost = () => {
        if (!storeData?.delivery_cost_enabled) return 0;
        const raw = storeData?.delivery_cost_details;
        const num = Number(raw);
        return Number.isNaN(num) ? 0 : Math.max(0, num);
    };

    const details = Array.isArray(orderData?.order_details) ? orderData.order_details : [];
    const productSubtotal = details.reduce(
        (prev, item) => prev + getOrderLineUnitPrice(item) * (Number(item?.quantity) || 0),
        0
    );
    const deliveryCost = getDeliveryCost();
    const storeCurrency = storeData?.currency ?? storeData?.store_plan?.currency ?? 'COP';
    const couponCode = orderData?.coupon_code ?? orderData?.coupon?.code ?? fetchedCouponCode ?? null;
    const couponName = orderData?.coupon_name ?? orderData?.coupon?.name ?? null;
    const couponDisplay =
        couponName && couponCode
            ? `${couponName} (${couponCode})`
            : couponName || couponCode || '—';
    const couponDiscountRaw =
        orderData?.coupon_discount_amount ??
        orderData?.coupon_discount ??
        orderData?.coupon?.discount_amount ??
        orderData?.coupon?.discount ??
        orderData?.applied_coupon?.discount_amount ??
        0;
    const couponDiscount = Math.max(0, Number(couponDiscountRaw) || 0);
    const hasCoupon = !!(couponCode || couponDiscount > 0);
    const grandTotal = Math.max(0, productSubtotal + deliveryCost - couponDiscount);

    // WhatsApp message for "Enviar enlace de pago" (same as OrderPaymentInfo)
    const getPaymentLinkMessage = () => {
        const clientName = `${orderData?.customer?.first_name ?? ''} ${orderData?.customer?.last_name ?? ''}`.trim() || 'Cliente';
        const clientPhone = (orderData?.customer?.phone_number ?? '').replace(/\D/g, '');
        const products = (orderData?.order_details ?? []).map((item) => {
            let product = '';
            if (item?.order_item_option?.length) {
                product = item.order_item_option.reduce((acc, current) => {
                    if (current?.product_option_value) {
                        return acc + `${current.product_option_value.name}, `;
                    }
                    return acc;
                }, '');
            }
            const price = item?.product?.discount_price || item?.product?.price || 0;
            return `- ${item?.quantity} *${item?.product?.name} ${item?.product?.sku}* ${product ? '- ' + product : ''}/  ${price > 0 ? `_${formatNumber(price, storeCurrency)}_` : ''} \n`;
        });
        const subtotal = productSubtotal;
        const shippingCost = deliveryCost;
        const discount = couponDiscount;
        const total = grandTotal;
        return `
Hola, ${clientName},
Este es tu pedido en ${storeData?.name ?? 'la tienda'}:
========================

${products.map((p) => p.trim()).join('\n')}

========================
*Subtotal productos:* _${formatNumber(subtotal, storeCurrency)}_
*Envío:* _${formatNumber(shippingCost, storeCurrency)}_
${discount > 0 ? `*Cupón${couponCode ? ` (${couponCode})` : ''}:* _- ${formatNumber(discount, storeCurrency)}_\n` : ''}*TOTAL:* _${formatNumber(total, storeCurrency)}_
${storeData?.shipping_time_enabled ? `*Tiempo de entrega:* ${storeData?.shipping_details || ''}` : ''}
========================

Tus datos:
*Nombre:* ${clientName}
*Celular:* +${clientPhone}

========================
Realiza el pago a través del siguiente enlace:
https://${storeData?.url ?? ''}.ecometri.shop/checkout/${storeData?.id ?? ''}/${id}/payment-link
========================
`.trim();
    };

    const handleStatusSave = () => {
        const payload = {
            ...orderData,
            user_store_id: orderData.user_store_id,
        };

        if (selectedPaymentStatus) {
            const paymentConfig = Object.values(paymentStatusConfigs).find(
                (c) => c.value === selectedPaymentStatus
            );
            if (paymentConfig) {
                payload.order_status_id = paymentConfig.value;
            }
        }

        if (selectedShipmentStatus) {
            const shipmentConfig = Object.values(shipmentStatusConfigs).find(
                (c) => c.value === selectedShipmentStatus
            );
            if (shipmentConfig) {
                payload.shipping_order_status_id = shipmentConfig.value;
            }
        }

        // Only call update if something actually changed
        if (payload.order_status_id || payload.shipping_order_status_id) {
            updateOrder(storeId, orderData.id, payload)
                .then(() => {
                    setTimeout(() => {
                        enqueueSnackbar(t('OrderDetail.submitSuccess'), successToast);
                    }, 1500);
                })
                .catch(() => {
                    setTimeout(() => {
                        enqueueSnackbar(t('OrderDetail.submitError'), errorToast);
                    }, 1500);
                });
        }

        setIsPaymentStatusDrawerOpen(false);
        setIsShipmentStatusDrawerOpen(false);
    };

    /**
     * Get the product data if an id is provided in the url
     */
    useEffect(() => {
        if (id) {
            setGettingOrder(true);
            /**
             * If the variable is not set it means the user got to the page using
             * only the url, get the store data from the api to show the info
             */
            getOrderService(storeId, id)
                .then(({ data }) => {
                    setGettingOrder(false);
                    setOrderData(data);
                    Mixpanel.track('Visitar resumen del pedido', {
                        'Canal de venta': data.user_store ? data.user_store.name : '',
                        productos: data.order_details,
                        pedido: data.sequence,
                        'ID pedido': id,
                    });
                })
                .catch(() => {
                    setGettingOrder(false);
                    enqueueSnackbar(t('OrderDetail.dataError'), errorToast);
                    history.push(routes.ordersPage);
                });

            getDynamicFormInfo(storeId, id)
                .then(({ data }) => {
                    setFormInfo(data);
                })
                .catch((err) => console.log(err));
            getUserStoresService(storeId).then(({ data }) => setUserStores(data));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id]);

    useEffect(() => {
        if (orderData?.shipping_information?.city_id) {
            getCitiesService()
                .then(({ data }) => {
                    const find = data.find((c) => c.id === orderData.shipping_information.city_id);
                    setCity(find);
                })
                .catch((err) => console.log(err));
        }
    }, [orderData?.shipping_information?.city_id]);

    useEffect(() => {
        if (orderData?.shipping_information?.country_code) {
            getStoreCountries()
                .then(({ data }) => {
                    const find = data.find((c) => c.code === orderData.shipping_information.country_code);
                    setCountry(find);
                })
                .catch((err) => console.log(err));
        }
    }, [orderData?.shipping_information?.country_code]);

    useEffect(() => {
        const couponId = orderData?.coupon_id;
        const hasCode = orderData?.coupon_code ?? orderData?.coupon?.code;
        if (!storeId || !couponId || hasCode) {
            setFetchedCouponCode(null);
            return;
        }
        getCouponService(storeId, couponId)
            .then((res) => setFetchedCouponCode(res?.data?.code ?? null))
            .catch(() => setFetchedCouponCode(null));
    }, [storeId, orderData?.coupon_id, orderData?.coupon_code, orderData?.coupon?.code]);

    // HOCs - Status chip rendering functions
    const getPaymentStatusChip = (value) => {
        const config = Object.values(paymentStatusConfigs).find((c) => c.value === value);
        if (config) {
            return (
                <Chip
                    label={config.label}
                    className={`${drawerClasses.statusChip} ${drawerClasses[config.class]}`}
                    size="small"
                />
            );
        }
    };

    const getShipmentStatusChip = (value) => {
        const config = Object.values(shipmentStatusConfigs).find((c) => c.value === value);
        if (config) {
            return (
                <Chip
                    label={config.label}
                    className={`${drawerClasses.statusChip} ${drawerClasses[config.class]}`}
                    size="small"
                />
            );
        }
    };

    const renderPaymentStatusOptions = () => {
        return Object.entries(paymentStatusConfigs).map(([key, config]) => (
            <FormControlLabel
                key={config.value}
                value={config.value}
                control={<Radio color="primary" />}
                label={
                    <div className={drawerClasses.statusOptionContent}>
                        {getPaymentStatusChip(config.value)}
                        <Typography variant="body2" color="textSecondary">
                            {config.description}
                        </Typography>
                    </div>
                }
                className={drawerClasses.statusOption}
            />
        ));
    };

    const renderShipmentStatusOptions = () => {
        return Object.entries(shipmentStatusConfigs).map(([key, config]) => (
            <FormControlLabel
                key={config.value}
                value={config.value}
                control={<Radio color="primary" />}
                label={
                    <div className={drawerClasses.statusOptionContent}>
                        {getShipmentStatusChip(config.value)}
                        <Typography variant="body2" color="textSecondary">
                            {config.description}
                        </Typography>
                    </div>
                }
                className={drawerClasses.statusOption}
            />
        ));
    };

    if (gettingOrder) {
        return (
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: '100vh',
                    textAlign: 'center',
                    padding: '16px',
                }}
            >
                <CircularProgress style={{ marginBottom: '20px', color: '#9EE870' }} />
                <Typography variant="h6" style={{ color: '#173300' }}>
                    Cargando los datos del pedido...
                </Typography>
                <Typography variant="body2" color="textSecondary">
                    Por favor espera un momento mientras preparamos la información.
                </Typography>
            </div>
        );
    }

    return (
        <div className={classes.root}>
            {/* Header */}
            <AppBar position="sticky" className={classes.appBar}>
                <Toolbar className={classes.toolbar}>
                    <Link to={routes.ordersPage} className={classes.headerLeft}>
                        <IconButton size="small">
                            <ArrowBackIcon />
                        </IconButton>
                        <Typography className={classes.breadcrumb}>Pedidos</Typography>
                    </Link>
                    <Typography className={classes.title}>Pedido</Typography>
                    <Button className={classes.editButton} onClick={handleEditOrder}>
                        Editar pedido
                    </Button>
                </Toolbar>

                <div className={classes.statusContainer}>
                    <div className={classes.statusChips}>
                        {orderData?.order_status_id &&
                            getPaymentStatusChip(orderData?.order_status_id)}
                        {orderData?.shipping_order_status_id &&
                            getShipmentStatusChip(orderData?.shipping_order_status_id)}
                    </div>
                    <IconButton size="small">
                        <VisibilityIcon />
                    </IconButton>
                </div>
            </AppBar>

            {/* Main Content */}
            <div className={classes.mainContent}>
                <OrderInvoiceButton
                    order={orderData}
                    store={storeData}
                    formInfo={formInfo}
                    fullWidth
                    variant="contained"
                />

                {/* Order Status Section */}
                <Card className={classes.section}>
                    <CardContent>
                        <Typography className={classes.sectionTitle}>Estado del pedido</Typography>
                        <Typography className={classes.infoValue} style={{ marginBottom: 16 }}>
                            {statusOrders[orderData?.order_status?.id]}
                        </Typography>
                        <Button className={classes.ctaButton} onClick={handleChangeOrderStatus}>
                            Cambiar estado del pedido
                        </Button>
                    </CardContent>
                </Card>

                {/* Payment Info Section */}
                <Card className={classes.section}>
                    <CardContent>
                        <Typography className={classes.sectionTitle}>
                            Información de pago
                        </Typography>
                        {(() => {
                            const origin = getOrderOrigin(orderData);
                            const payment = orderData?.order_payment;
                            const paymentStatus = getNormalizedPaymentStatusLabel(payment);
                            const amountValue = Number(payment?.amount);
                            const hasAmount =
                                payment?.amount != null &&
                                payment?.amount !== '' &&
                                !Number.isNaN(amountValue);
                            const paymentDate = payment?.transaction_date
                                ? new Date(payment.transaction_date)
                                : null;
                            const hasValidDate = paymentDate && !Number.isNaN(paymentDate.getTime());

                            return (
                                <>
                                    <div className={classes.infoRow}>
                                        <span className={classes.infoLabel}>Canal</span>
                                        <span className={classes.infoValue}>{origin.channelLabel}</span>
                                    </div>
                                    {origin.isGateway ? (
                                        <div className={classes.infoRow}>
                                            <span className={classes.infoLabel}>Pasarela</span>
                                            <span className={classes.infoValue}>{origin.primaryLabel}</span>
                                        </div>
                                    ) : (
                                        <div className={classes.infoRow}>
                                            <span className={classes.infoLabel}>Línea/Sucursal</span>
                                            <span className={classes.infoValue}>{origin.primaryLabel}</span>
                                        </div>
                                    )}
                                    {payment ? (
                                        <>
                                            {paymentStatus && (
                                                <div className={classes.infoRow}>
                                                    <span className={classes.infoLabel}>Estado del pago</span>
                                                    <span className={classes.infoValue}>{paymentStatus}</span>
                                                </div>
                                            )}
                                            {hasAmount && (
                                                <div className={classes.infoRow}>
                                                    <span className={classes.infoLabel}>Valor pagado</span>
                                                    <span className={classes.infoValue}>
                                                        {formatNumber(
                                                            amountValue,
                                                            payment?.currency || storeData?.currency
                                                        )}
                                                    </span>
                                                </div>
                                            )}
                                            {payment?.platform_reference && (
                                                <div className={classes.infoRow}>
                                                    <span className={classes.infoLabel}>Referencia</span>
                                                    <span className={classes.infoValue}>
                                                        {payment.platform_reference}
                                                    </span>
                                                </div>
                                            )}
                                            {hasValidDate && (
                                                <div className={classes.infoRow}>
                                                    <span className={classes.infoLabel}>Fecha del pago</span>
                                                    <span className={classes.infoValue}>
                                                        {paymentDate.toLocaleString()}
                                                    </span>
                                                </div>
                                            )}
                                        </>
                                    ) : (
                                        <>
                                            <Typography variant="body2" style={{ marginBottom: 12 }}>
                                                El cliente no ha realizado el pago
                                            </Typography>
                                            <a
                                                href={`https://wa.me/${(orderData?.customer?.phone_number ?? '').replace(/\D/g, '')}?text=${encodeURIComponent(getPaymentLinkMessage())}`}
                                                target="_blank"
                                                className={classes.whatsappButton}
                                                rel="noopener noreferrer"
                                            >
                                                <WhatsAppIcon style={{ color: '#25D366' }} />
                                                <span>Enviar enlace de pago</span>
                                            </a>
                                        </>
                                    )}
                                </>
                            );
                        })()}
                    </CardContent>
                </Card>

                {/* Customer Section */}
                <Card className={classes.section}>
                    <CardContent>
                        <Typography className={classes.sectionTitle}>Cliente</Typography>
                        <div>
                            <div className={classes.infoRow}>
                                <span className={classes.infoLabel}>Nombre</span>
                                <span className={classes.infoValue}>
                                    {orderData?.customer?.first_name ?? ''}
                                </span>
                            </div>
                            <div className={classes.infoRow}>
                                <span className={classes.infoLabel}>Email</span>
                                <span className={classes.infoValue}>
                                    {orderData?.customer?.email ?? ''}
                                </span>
                            </div>
                            <div className={classes.infoRow}>
                                <span className={classes.infoLabel}>Teléfono</span>
                                <span className={classes.infoValue}>
                                    {orderData?.customer?.phone_number ?? ''}
                                </span>
                            </div>
                            <div className={classes.infoRow}>
                                <span className={classes.infoLabel}>Identificación</span>
                                <span className={classes.infoValue}>
                                    {orderData?.customer?.document_type ?? ''}{' '}
                                    {orderData?.customer?.dni ?? ''}
                                </span>
                            </div>
                            {orderData?.customer?.phone_number && (
                                <div className={classes.infoRow}>
                                    <span className={classes.infoLabel}>WhatsApp</span>
                                    <a
                                        href={`https://wa.me/${orderData.customer.phone_number}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        <WhatsAppIcon style={{ color: '#25D366' }} />
                                    </a>
                                </div>
                            )}
                        </div>
                    </CardContent>
                </Card>

                {/* Shipping Info Section */}
                <Card className={classes.section}>
                    <CardContent>
                        <Typography className={classes.sectionTitle}>Datos de envío</Typography>
                        <div style={{ marginBottom: 16 }}>
                            <div className={classes.infoRow}>
                                <span className={classes.infoLabel}>
                                    {t('OrderDetail.shipping.phone')}
                                </span>
                                <span className={classes.infoValue}>
                                    +{orderData?.customer?.phone_number ?? ''}
                                </span>
                            </div>
                            <div className={classes.infoRow}>
                                <span className={classes.infoLabel}>
                                    {t('OrderDetail.shipping.name')}
                                </span>
                                <span className={classes.infoValue} style={{ textTransform: 'capitalize' }}>
                                    {orderData?.customer?.first_name ?? ''}{' '}
                                    {orderData?.customer?.last_name ?? ''}
                                </span>
                            </div>
                            {orderData?.shipping_information?.address && (
                                <div className={classes.infoRow} style={{ alignItems: 'flex-start' }}>
                                    <span className={classes.infoLabel}>
                                        {t('OrderDetail.shipping.address')}
                                    </span>
                                    <div className={classes.addressValue}>
                                        {orderData.shipping_information.address}
                                    </div>
                                </div>
                            )}
                            {orderData?.shipping_information?.address_detail && (
                                <div className={classes.infoRow}>
                                    <span className={classes.infoLabel}>
                                        {t('OrderDetail.shipping.address_detail')}
                                    </span>
                                    <span className={classes.infoValue}>
                                        {orderData.shipping_information.address_detail}
                                    </span>
                                </div>
                            )}
                            {!orderData?.shipping_information?.city_id ||
                            orderData?.shipping_information?.city_id !== 688 ? (
                                <>
                                    {city?.name && (
                                        <div className={classes.infoRow}>
                                            <span className={classes.infoLabel}>
                                                {t('OrderDetail.shipping.city')}
                                            </span>
                                            <span className={classes.infoValue}>{city.name}</span>
                                        </div>
                                    )}
                                    {city?.state && (
                                        <div className={classes.infoRow}>
                                            <span className={classes.infoLabel}>
                                                {t('OrderDetail.shipping.state')}
                                            </span>
                                            <span className={classes.infoValue}>{city.state}</span>
                                        </div>
                                    )}
                                </>
                            ) : null}
                            {country?.name && (
                                <div className={classes.infoRow}>
                                    <span className={classes.infoLabel}>
                                        {t('OrderDetail.shipping.country')}
                                    </span>
                                    <span className={classes.infoValue}>{country.name}</span>
                                </div>
                            )}
                        </div>

                        <div className={classes.divider} />

                        <div style={{ marginBottom: 16 }}>
                            <Typography
                                variant="body2"
                                style={{ fontWeight: 500, color: '#173300', marginBottom: 8 }}
                            >
                                Estado del envío
                            </Typography>
                            <Typography className={classes.infoLabel} style={{ marginBottom: 16 }}>
                                {
                                    Object.values(shipmentStatusConfigs).find(
                                        (c) => c.value === orderData?.shipping_order_status_id
                                    )?.label
                                }
                            </Typography>
                        </div>

                        <Button className={classes.ctaButton} onClick={handleChangeShippingStatus}>
                            Cambiar estado del envío
                        </Button>
                    </CardContent>
                </Card>

                <Card className={classes.section}>
                    <Typography variant="h6">Fecha y hora del pedido</Typography>
                    <TextField
                        type="datetime-local"
                        value={moment(orderData.created_at).format('YYYY-MM-DDTHH:mm')}
                        onChange={handleDateChange}
                        variant="outlined"
                        fullWidth
                        style={{ marginTop: 8 }}
                    />
                </Card>
                <Card className={classes.section}>
                    <Typography variant="h6">Canal de venta</Typography>
                    <FormControl variant="outlined" fullWidth style={{ marginTop: 16 }}>
                        <InputLabel id="store-select-label">Canal de venta</InputLabel>
                        <Select
                            value={orderData?.user_store?.id ?? ''}
                            onChange={handleStoreChange}
                            label="Canal de venta"
                            variant="outlined"
                        >
                            {userStores.map((store) => (
                                <MenuItem key={store.id} value={store.id}>
                                    {store.name}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Card>

                {/* Order Details Section */}
                <Card className={classes.section}>
                    <CardContent>
                        <div className={classes.orderMeta}>
                            <Typography className={classes.sectionTitle}>
                                Detalles del pedido
                            </Typography>
                            <Typography className={classes.orderDate}>{orderData?.date}</Typography>
                            <Typography className={classes.salesChannel}>
                                Canal de venta:{' '}
                                {(() => {
                                    const origin = getOrderOrigin(orderData);
                                    return `${origin.channelLabel} · ${origin.primaryLabel}`;
                                })()}
                            </Typography>
                        </div>

                        <TableContainer>
                            <Table className={classes.productTable}>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Producto</TableCell>
                                        <TableCell align="center">Cant.</TableCell>
                                        <TableCell align="right">Subtotal</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {orderData?.order_details?.map((item) => (
                                        <TableRow key={item.id} className={classes.productRow}>
                                            <TableCell>
                                                <div className={classes.productInfo}>
                                                    <img
                                                        className={classes.productImage}
                                                        src={
                                                            item?.product?.product_images?.[0]
                                                                ?.picture_url
                                                                ? `${process.env.REACT_APP_IMAGES_API_URL}fit-in/600x600/${item?.product?.product_images?.[0]?.picture_url}`
                                                                : `https://ui-avatars.com/api/?name=${encodeURIComponent(item?.product?.name || '')}&size=80&background=CAD7CA&color=fff`
                                                        }
                                                        alt={
                                                            item?.product?.product_images?.[0]
                                                                ?.name ||
                                                            item?.product?.name ||
                                                            ''
                                                        }
                                                    />
                                                    <div className={classes.productDetails}>
                                                        <div className="product-name">
                                                            {item?.product?.name}
                                                        </div>
                                                        <div className="product-variant">
                                                            Variación: {renderVariants(item)}
                                                        </div>
                                                        <div className="product-sku">
                                                            SKU: {getOrderLineSku(item)}
                                                        </div>
                                                    </div>
                                                </div>
                                            </TableCell>
                                            <TableCell align="center">{item?.quantity}</TableCell>
                                            <TableCell align="right">
                                                {formatNumber(
                                                    getOrderLineUnitPrice(item) * (item?.quantity || 0),
                                                    storeCurrency
                                                )}
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>

                        <div className={classes.totalSection}>
                            <div className={classes.totalRow}>
                                <span className={classes.infoLabel}>Subtotal</span>
                                <span className={classes.infoValue}>
                                    {formatNumber(productSubtotal, storeCurrency)}
                                </span>
                            </div>
                            <div className={classes.totalRow}>
                                <span className={classes.infoLabel}>Costos de envío</span>
                                <span className={classes.infoValue}>
                                    {formatNumber(deliveryCost, storeCurrency)}
                                </span>
                            </div>
                            {hasCoupon && (
                                <>
                                    <div className={classes.totalRow}>
                                        <span className={classes.infoLabel}>Cupón</span>
                                        <span className={classes.infoValue}>{couponDisplay}</span>
                                    </div>
                                    <div className={classes.totalRow}>
                                        <span className={classes.infoLabel}>Descuento</span>
                                        <span className={classes.infoValue}>
                                            - {formatNumber(couponDiscount, storeCurrency)}
                                        </span>
                                    </div>
                                </>
                            )}
                            <div className={`${classes.totalRow} total-final`}>
                                <span style={{ color: '#173300' }}>Total</span>
                                <span style={{ color: '#173300' }}>
                                    {formatNumber(grandTotal, storeCurrency)}
                                </span>
                            </div>
                        </div>
                    </CardContent>
                </Card>

                {/* Order Comments Section */}
                <Card className={classes.section}>
                    <CardContent>
                        <Typography className={classes.sectionTitle}>
                            Comentarios del pedido
                        </Typography>
                        <OutlinedInput
                            className={classes.commentsBox}
                            value={orderData?.comments ?? ''}
                            onChange={handleOnCommentsChange}
                        />
                    </CardContent>
                </Card>

                {/* Custom Form Section */}
                <Card className={classes.section}>
                    <CardContent>
                        <Typography className={classes.sectionTitle}>
                            Respuestas del formulario personalizado
                        </Typography>
                        <div>
                            {formInfo?.map((form) => (
                                <div className={classes.infoRow}>
                                    <span className={classes.infoLabel}>{form.title}</span>
                                    <span className={classes.infoValue}>{form.response}</span>
                                </div>
                            ))}
                        </div>
                    </CardContent>
                </Card>
            </div>
            {/* Payment Status Change Dialog */}
            <Drawer
                anchor="bottom"
                open={isPaymentStatusDrawerOpen}
                onClose={() => setIsPaymentStatusDrawerOpen(false)}
                PaperProps={{ style: { borderRadius: '16px 16px 0px 0px' } }}
            >
                <div className={drawerClasses.dialogTitle}>
                    <Typography variant="h6">Cambiar estado</Typography>
                    <IconButton onClick={() => setIsPaymentStatusDrawerOpen(false)}>
                        <CloseIcon />
                    </IconButton>
                </div>
                <div>
                    <RadioGroup value={selectedPaymentStatus} onChange={handlePaymentStatusChange}>
                        {renderPaymentStatusOptions()}
                    </RadioGroup>
                </div>
                <div
                    style={{
                        padding: '16px 24px',
                        display: 'flex',
                        justifyContent: 'space-between',
                    }}
                >
                    <Button
                        onClick={() => setIsPaymentStatusDrawerOpen(false)}
                        style={{ color: '#4A4A4A', flex: 1 }}
                        fullWidth
                    >
                        Cancelar
                    </Button>
                    <Button
                        onClick={handleStatusSave}
                        style={{ backgroundColor: '#9EE870', color: 'white', flex: 1 }}
                        fullWidth
                    >
                        Guardar
                    </Button>
                </div>
            </Drawer>

            {/* Shipment Status Change Dialog */}
            <Drawer
                anchor="bottom"
                open={isShipmentStatusDrawerOpen}
                onClose={() => setIsShipmentStatusDrawerOpen(false)}
                PaperProps={{ style: { borderRadius: '16px 16px 0px 0px' } }}
            >
                <div className={drawerClasses.dialogTitle}>
                    <Typography variant="h6">Cambiar estado</Typography>
                    <IconButton onClick={() => setIsShipmentStatusDrawerOpen(false)}>
                        <CloseIcon />
                    </IconButton>
                </div>
                <div>
                    <RadioGroup
                        value={selectedShipmentStatus}
                        onChange={handleShipmentStatusChange}
                    >
                        {renderShipmentStatusOptions()}
                    </RadioGroup>
                </div>
                <div
                    style={{
                        padding: '16px 24px',
                        display: 'flex',
                        justifyContent: 'space-between',
                    }}
                >
                    <Button
                        onClick={() => setIsShipmentStatusDrawerOpen(false)}
                        style={{ color: '#4A4A4A', flex: 1 }}
                        fullWidth
                    >
                        Cancelar
                    </Button>
                    <Button
                        onClick={handleStatusSave}
                        style={{ backgroundColor: '#9EE870', color: 'white', flex: 1 }}
                        fullWidth
                    >
                        Guardar
                    </Button>
                </div>
            </Drawer>
        </div>
    );
};

const mapStateToProps = ({ auth, orders, common }) => ({
    storeId: auth.storeId,
    orderToEdit: orders.orderToEdit,
    storeData: common.storeData,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            setOrderToEdit,
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(OrderInfoPageMobile);
